import Vue from 'vue'
import { mapValues, findIndex } from'lodash'


export const namespaced = true


const stateObj = {
	movingAssets: [],
}
export const state = () => stateObj


export const mutations = {
	...mapValues(stateObj, (val, key) => (state, data) => state[key] = data),
	addMovingAsset(state, asset) {
		var existingIndex = findIndex(state.movingAssets, {id: asset.id});
		if(existingIndex === -1)
		{
			state.movingAssets.push(asset);
		}
	},
	removeMovingAsset(state, asset) {
		var existingIndex = findIndex(state.movingAssets, {id: asset.id});
		if(existingIndex !== -1)
		{
			state.movingAssets.splice(existingIndex, 1);
		}
	},
}


export const actions = {
}


export const getters = {
	...mapValues(stateObj, (val, key) => (state) => state[key]),
}



// WEBPACK FOOTER //
// ./src/store/admin.js